import { keepPreviousData, useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewTags = (page = 1, pageSize = 10, q = "") => {
    const normalizedSearch = q.trim();

    return useQuery({ 
        queryKey: ['viewtags', page, pageSize, normalizedSearch], 
        queryFn: async () => { 
            const res = await api.get('/tags/show', {
                params: {
                    page,
                    limit: pageSize,
                    ...(normalizedSearch ? { q: normalizedSearch } : {}),
                },
            }); 
            return res.data; 
        },
        placeholderData: keepPreviousData,
        staleTime: 30000,
     });
};  